<template>
    <div>
        <v-select :items="operators" label="Select Operator" v-model="booking.bookingMadeBy" />
        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
                <v-text-field :value="computedDateFormattedMomentjs" clearable label="Start Date" readonly v-on="on" />
            </template>
            <v-date-picker :first-day-of-week="1" v-model="booking.startDate" @change="menu1 = false" />
        </v-menu>
        <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="booking.startTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field v-model="booking.startTime" label="Drop off time" readonly v-on="on" />
            </template>
            <v-time-picker v-if="menu2" v-model="booking.startTime" full-width @click:minute="$refs.menu.save(booking.startTime)" />
        </v-menu>
        <v-text-field v-model.number="booking.days" label="Number of Days" />
        <div v-if="booking.days > 0 && booking.dailyTotals.length < booking.days">
            <v-container fluid grid-list-md>
                <v-row>
                    <v-col>
                        <v-text-field disabled v-model.number="selectedDay" label="Day"/>
                    </v-col>
                    <v-col>
                        <v-text-field v-model.number="selectedTotal" label="Total"/>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="selectedIsPdr" color="primary" label="PDR"/>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="selectedIsAlloys" color="primary" label="Alloys"/>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="selectedIsCCar" color="primary" label="Courtesy Car"/>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="selectedIsDropOff" color="primary" label="Drop Off"/>
                    </v-col>
                    <v-col>
                        <v-checkbox v-model="selectedIsPickUp" color="primary" label="Pick Up"/>
                    </v-col>
                </v-row>
            </v-container>
            <v-btn @click="addDay" color="primary">Add Day</v-btn>
        </div>
        <div class="mt-2 mb-3" v-if="booking.dailyTotals && booking.dailyTotals.length > 0">
            <v-card class="text-xs-left" v-for="(day, index) in booking.dailyTotals" :key="index">
                <v-row class="pa-1">
                    <h6 class="ml-3 title">Day: {{day.day}} - £{{day.total}}</h6>
                    <div class="ml-3">
                        <v-chip small v-if="day.isPdr" color="yellow"><strong>PDR</strong></v-chip>
                        <v-chip small v-if="day.isAlloys" color="orange"><strong>Alloys</strong></v-chip>
                        <v-chip small v-if="day.isCCar" color="green"><strong>Courtesy Car</strong></v-chip>
                        <v-chip small v-if="day.isDropOff" color="#996699" class="white--text"><strong>Drop Off</strong></v-chip>
                        <v-chip small v-if="day.isPickUp" color="#333399" class="white--text"><strong>Pick Up</strong></v-chip>
                    </div>
                    <v-spacer/>
                    <v-btn @click="deleteDay(index)" text color="error"><v-icon>mdi-delete</v-icon></v-btn>
                </v-row>
            </v-card>
        </div>
        <v-select v-model="activeNote" :items="notes" label="Quick Enter Note" item-text="name" item-value="name"/>
        <v-textarea v-model="booking.notes" label="Notes"/>
        <v-textarea v-model="booking.hiddenNotes" label="Hidden Notes"/>
        <v-text-field prefix="£" v-model.number="booking.total" label="Total excluding VAT"/>
        <v-text-field v-model="booking.discountNotes" label="Discount Note"/>
        <v-text-field v-model.number="booking.discountValue" label="Discount Value"/>
        <h4 v-if="booking.discountValue > 0 && renderComponent" class="display-1">Total Including VAT - £{{parseFloat((booking.total - booking.discountValue) + (booking.total - booking.discountValue) * 0.20).toFixed(2)}}</h4>
        <h4 v-if="!booking.discountValue && renderComponent" class="display-1">Total Including VAT - £{{parseFloat(booking.total + booking.total * 0.20).toFixed(2)}}</h4>
    </div>
</template>

<script>
    import {NotesHttp} from "../../../../http/notes";
    import {EventBus} from "../../../../EventBus";

    export default {
        name: "RsDetails",
        props: {
            booking: Object
        },
        async mounted() {
            this.notes = await NotesHttp.getAllNotes();
            EventBus.$on('reset-booking', () => {
                this.selectedDay = 1;
            })
        },
        computed: {
            computedDateFormattedMomentjs () {
                return this.booking.startDate ? this.$moment(this.booking.startDate).format('DD/MM/YYYY') : ''
            },
        },
        watch: {
            activeNote(newVal) {
                if (!this.booking.notes || this.booking.notes.length === 0) {
                    this.booking.notes = `${newVal}`;
                } else {
                    this.booking.notes = this.booking.notes + `\n${newVal}`;
                }
                this.activeNote = '';
            },
            'booking.days'(newVal) {
                if (newVal) {
                    if (this.booking.dailyTotals && this.booking.dailyTotals.length > 0) {
                        this.selectedDay = this.booking.dailyTotals.length + 1;
                    } else {
                        this.booking.dailyTotals = [];
                        this.selectedDay = 1;
                    }
                }
            }
        },
        data() {
            return {
                operators: [
                    'Nick',
                    'Mike'
                ],
                notes: [],
                activeNote: '',
                selectedDay: 1,
                selectedTotal: 0,
                selectedIsPdr: false,
                selectedIsAlloys: false,
                selectedIsCCar: false,
                selectedIsDropOff: false,
                selectedIsPickUp: false,
                menu1: false,
                menu2: false,
                renderComponent: true
            }
        },
        methods: {
            forceRerender() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            },
            addDay() {
                this.booking.dailyTotals.push({day: this.selectedDay, total: this.selectedTotal, isPdr: this.selectedIsPdr, isAlloys: this.selectedIsAlloys, isCCar: this.selectedIsCCar, isDropOff: this.selectedIsDropOff, isPickUp: this.selectedIsPickUp});
                this.selectedDay = this.selectedDay + 1;
                this.selectedTotal = 0;
                this.selectedIsPdr = false;
                this.selectedIsAlloys = false;
                this.selectedIsCCar = false;
                this.selectedIsDropOff = false;
                this.selectedIsPickUp = false;
            },
            deleteDay(day) {
                this.booking.dailyTotals.splice(day, 1);
                if (this.selectedDay !== 1) {
                    this.selectedDay = this.selectedDay - 1;
                }
            }
        }
    }
</script>

<style scoped>

</style>
